import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";
import {GlobalsDialogService} from "../../../globals/services/globals-dialogs-service.service";
import {CommonsAlertsService} from "../../../commons/services/commons-alerts.service";


export class GlobalsViewCtrl implements IController {

  globals: any;

  constructor(private $log, private globalsDialogService: GlobalsDialogService, private commonsAlertsService: CommonsAlertsService) {
  }

  onEdit(event, property, index) {
    this.globalsDialogService.editGlobalProperty(event, property)
      .then((updatedValue) => {
        if (updatedValue.group) {
          const group = _.camelCase(updatedValue.group);
          this.globals[group].list[index] = updatedValue;
        } else {
          this.$log.info('No Group After Server Update', updatedValue);
        }
        this.commonsAlertsService.preferencesByNameSuccess('globals.' + property.key + '.name');
      })
      .catch((error) => {
        if (error) {
          this.commonsAlertsService.preferencesError();
        } else {
          this.$log.info('Dialog Closed');
        }
      })
  }


}

angular
  .module('bringoz.admin.organizations')
  .component('globalsView', {
    bindings: {
      globals: '<'
    },
    template: require('./globals-view.html').default,
    controller: GlobalsViewCtrl
  });
